export { MasterCustomerFormView } from './src/master'
